import { createSelector } from 'reselect';

export const selectMarketingTopBanner = state => state.marketingTopBanner;

export const selectMarketingTopBannerConfig =
  createSelector(selectMarketingTopBanner, ({ config }) => config);
export const selectMarketingTopBannerIsLoaded =
  createSelector(selectMarketingTopBanner, ({ isLoaded }) => isLoaded);
export const selectMarketingTopBannerIsLoading =
  createSelector(selectMarketingTopBanner, ({ isLoading }) => isLoading);
export const selectMarketingTopBannerPlacement =
  createSelector(selectMarketingTopBanner, ({ placement }) => placement);
